import React, {PureComponent} from 'react';
import { ContentNavItem } from './nav/NavItem';
import navState from './nav/navState';
import ScrollToTopButton from './common/scroll/ScrollToTopButton';
import Spinner from 'react-bootstrap/Spinner';
import globalActivityState from '../../model/globalActivityState';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/button';
import logo from './logo/logo.png';
import navRedirects from './nav/navRedirects';

interface Props {}

interface State {
  mainContainerWidth: number,
  mainContainerHeight: number,
  currentContentNavItem: ContentNavItem
  currentSecondaryNavItems: string[]
  modalNavItem: undefined | ContentNavItem
  busy: boolean
}

const renderLogo = false;
const renderDebug = false;

export default class MainView extends PureComponent<Props, State> {

  mainContainerRef: any = undefined;
  active: boolean = false;
  state: State = {
    mainContainerWidth: 900,
    mainContainerHeight: 900,
    currentContentNavItem: navState.getCurrentContentNavItem(),
    currentSecondaryNavItems: navState.getSecondaryNavItems(),
    modalNavItem: undefined,
    busy: globalActivityState.isBusy(),
  };


  constructor(props: Props) {
    super(props);
    navRedirects.execute();
  }

  onWindowResize = () => {
    const marginX = 20;
    const width = (this.mainContainerRef ? this.mainContainerRef.offsetWidth : 900) - 2 * marginX;
    const height = this.mainContainerRef ? this.mainContainerRef.offsetHeight : 500;
    this.setState({
      mainContainerWidth: width,
      mainContainerHeight: height
    });
  }

  onModalClose = () => {
    navState.setModalNavItem(undefined);
  }

  componentDidMount() {
    this.active = true;
    navState.registerListener(this.onNavStateChange);
    globalActivityState.registerListener(this.onGlobalActivityStateChange);
    window.addEventListener("resize", this.onWindowResize);
    this.onWindowResize();
  }

  componentWillUnmount() {
    this.active = false;
    navState.unregisterListener(this.onNavStateChange);
    globalActivityState.unregisterListener(this.onGlobalActivityStateChange);
    window.removeEventListener("resize", this.onWindowResize);
  }

  onNavStateChange = (navItem: ContentNavItem) => {
    if (this.active) {
      const modalNavItem = navState.getModalNavItem();
      this.setState({
        currentContentNavItem: navItem,
        modalNavItem: modalNavItem
      });

      // Not sure why this is necessary
      if (modalNavItem) {
        setTimeout(() => {
          this.forceUpdate();
        }, 0);
      }
    }
  }

  onGlobalActivityStateChange = () => {
    if (this.active) {
      this.setState({
        busy: globalActivityState.isBusy()
      });
    }
  }

  renderNavItem = (navItem: ContentNavItem, secondaryNavItems: string[]) => {
    return navItem.renderMainView(navItem, secondaryNavItems, this.state.mainContainerWidth, this.state.mainContainerHeight);
  }

  renderModal = () => {
    if (this.state.modalNavItem) {
      const renderedModalContent = this.state.modalNavItem.renderMainView(this.state.modalNavItem, [], 200, 100);
      return (
        <Modal.Dialog>
          <Modal.Header closeButton>
            <Modal.Title>{this.state.modalNavItem.name}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {renderedModalContent}
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={this.onModalClose}>Close</Button>
          </Modal.Footer>
        </Modal.Dialog>
      );
    } else {
      return null
    }
  }

  renderSpinner = () => {
    return (
      <div style={{ position: 'fixed', zIndex: 100, top: '45%', width: '100%', left: '0px' }}>
        <div style={{ width: '100px', marginTop: '20px', marginLeft: 'auto', marginRight: 'auto' }}>
          <Spinner animation="border" />
        </div>
      </div>
    );
  };

  renderDebug = () => {
    const currentNavItem = navState.getCurrentContentNavItem();
    return (
      <div style={{backgroundColor: 'red'}}>
        <div>Debug rendered by MainView:</div>
        <div>Current Nav Item: {currentNavItem ? currentNavItem.name : '????'}</div>
        <div>this.state.currentContentNavItem: {this.state.currentContentNavItem ? this.state.currentContentNavItem.name : '????'}</div>
      </div>
    );
  }

  renderLogo = () => {
    return (
      <img src={logo} className="App-logo" alt="logo" />
    )
  }

  render() {
    const renderedModal = this.renderModal();
    return (
      <>
        {renderedModal}
        <div
          style={{ marginTop: '0px', width: '100%', height: `100%` }}
          ref={(mainContainerRef) => {
            const resized = this.mainContainerRef !== mainContainerRef;
            this.mainContainerRef = mainContainerRef;
            if (resized) {
              this.onWindowResize();
            }
          }}
        >
          {this.renderNavItem(this.state.currentContentNavItem, this.state.currentSecondaryNavItems)}
          <ScrollToTopButton />
          {this.state.busy ? this.renderSpinner() : null}
          {renderLogo ? this.renderLogo() : null}
          {renderDebug ? this.renderDebug() : null}
        </div>
      </>
    );
  }

}
